module.exports = __webpack_public_path__ + "static/media/sign_out.7bcf8cd6.svg";